module.exports = __webpack_public_path__ + "img/library_video.e0d6e29a.svg";